import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ContactModal = ({ lot, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    contactMethod: 'phone',
    message: ''
  });

  const [errors, setErrors] = useState({});

  const contactMethodOptions = [
    { value: 'phone', label: 'Teléfono' },
    { value: 'email', label: 'Correo electrónico' }
  ];

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.fullName?.trim()) {
      newErrors.fullName = 'El nombre completo es requerido';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Ingrese un correo electrónico válido';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'El teléfono es requerido';
    } else if (!/^\d{9}$/?.test(formData?.phone?.replace(/\s/g, ''))) {
      newErrors.phone = 'Ingrese un número de teléfono válido (9 dígitos)';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onSubmit({ ...formData, lotId: lot?.id });
    }
  };

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* Modal */}
      <div className="relative bg-card rounded-xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-4 md:p-6 border-b border-border flex items-center justify-between">
          <div>
            <h3 className="text-xl md:text-2xl font-semibold mb-1">Contactar Asesor</h3>
            <p className="text-sm text-muted-foreground">Lote {lot?.number} - {lot?.area} m²</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl hover:bg-muted transition-smooth flex items-center justify-center touch-target focus-ring"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-4 md:p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Lot Summary */}
            <div className="p-4 bg-muted/50 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Home" size={24} color="var(--color-primary)" />
                </div>
                <div className="flex-1">
                  <div className="font-medium mb-1">Lote {lot?.number}</div>
                  <div className="text-sm text-muted-foreground mb-2">{lot?.area} m² • {lot?.location}</div>
                  <div className="text-lg font-semibold text-primary">
                    S/ {lot?.price?.toLocaleString('es-PE')}
                  </div>
                </div>
              </div>
            </div>

            {/* Form Fields */}
            <Input
              label="Nombre completo"
              type="text"
              placeholder="Ingrese su nombre completo"
              value={formData?.fullName}
              onChange={(e) => handleChange('fullName', e?.target?.value)}
              error={errors?.fullName}
              required
            />

            <Input
              label="Correo electrónico"
              type="email"
              placeholder="ejemplo@correo.com"
              value={formData?.email}
              onChange={(e) => handleChange('email', e?.target?.value)}
              error={errors?.email}
              required
            />

            <Input
              label="Teléfono"
              type="tel"
              placeholder="999 999 999"
              value={formData?.phone}
              onChange={(e) => handleChange('phone', e?.target?.value)}
              error={errors?.phone}
              required
            />

            <Select
              label="Método de contacto preferido"
              options={contactMethodOptions}
              value={formData?.contactMethod}
              onChange={(value) => handleChange('contactMethod', value)}
            />

            <div>
              <label className="block text-sm font-medium mb-2">
                Mensaje adicional (opcional)
              </label>
              <textarea
                className="w-full h-24 px-4 py-3 rounded-xl border border-input bg-background transition-smooth focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 resize-none"
                placeholder="Cuéntenos más sobre sus necesidades..."
                value={formData?.message}
                onChange={(e) => handleChange('message', e?.target?.value)}
              />
            </div>

            {/* Info Box */}
            <div className="flex items-start gap-3 p-4 bg-primary/10 rounded-xl">
              <Icon name="Info" size={20} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
              <p className="text-sm">
                Un asesor especializado se pondrá en contacto con usted en las próximas 24 horas para brindarle información detallada sobre este lote.
              </p>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="p-4 md:p-6 border-t border-border flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            fullWidth
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            variant="default"
            fullWidth
            iconName="Send"
            iconPosition="left"
            onClick={handleSubmit}
          >
            Enviar Solicitud
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;